// Preços dos planos em centavos (para evitar problemas de precisão com float)
export const PLAN_PRICES = {
  SEMESTER: 89900, // R$ 899,00
  YEARLY: 167900, // R$ 1.679,00
}

export const PLAN_PRICE_IDS = {
  SEMESTER: import.meta.env.VITE_STRIPE_PRICE_SEMESTER,
  YEARLY: import.meta.env.VITE_STRIPE_PRICE_YEARLY,
}
